import * as Yup from "yup";

export const validate = Yup.object().shape({
  idCentroMedico: Yup.number()
    .typeError("Debe seleccionar un centro médico")
    .required("Debe seleccionar un centro médico"),
  // idEspecialidad: Yup.number()
  //   .when('idCentroMedico', {
  //     is: 3,
  //     then: Yup.number()
  //       .typeError("Debe seleccionar una especialidad")
  //       .required("Debe seleccionar una especialidad"),
  //     otherwise: Yup.number().notRequired(),
  //   }),
});